function createProductCardSrcset(imageUrl, widths) {
  if (!imageUrl) return '';
  var url = new URL(imageUrl, window.location.origin);
  var requestedWidths = widths || [200, 300, 400];
  return requestedWidths.map(function (width) {
    url.searchParams.set('width', width);
    return url.href + ' ' + width + 'w';
  }).join(', ');
}

function setResponsiveProductCardImage(image, source, alt) {
  if (!image || !source) return;
  image.src = source;
  image.srcset = createProductCardSrcset(source);
  if (alt !== undefined) image.alt = alt;
}

function updateProductCardFromSwatch(colorSwatch, productItem, options) {
  options = options || {};
  var primaryImage = productItem.querySelector('.product-item__primary-image');
  var imageWrapper = productItem.querySelector('.product-item__image-wrapper');
  var cardLink = productItem.querySelector('.product-item__aspect-ratio');
  var radio = colorSwatch.querySelector('.color-swatch__radio');
  if (!radio) return;

  var variantId = radio.dataset.variantId;
  var primaryImageUrl = colorSwatch.dataset.img;
  var hoverImageUrl = colorSwatch.dataset.hoverImage;
  var primaryAlt = colorSwatch.dataset.alt || '';
  var hoverAlt = colorSwatch.dataset.hoverImageAlt || primaryAlt;

  radio.checked = true;
  setResponsiveProductCardImage(primaryImage, primaryImageUrl, primaryAlt);
  if (primaryImage) primaryImage.dataset.currentColor = (radio.value || '').toLowerCase();

  if (imageWrapper) {
    if (hoverImageUrl && hoverImageUrl !== primaryImageUrl) {
      imageWrapper.dataset.hoverImage = hoverImageUrl;
      imageWrapper.dataset.hoverImageAlt = hoverAlt;
    } else {
      delete imageWrapper.dataset.hoverImage;
      delete imageWrapper.dataset.hoverImageAlt;
      imageWrapper.querySelector('.product-item__secondary-image')?.remove();
      imageWrapper.classList.remove('product-item__image-wrapper--multiple');
    }
  }

  // A hover image may already be mounted from the previous color selection.
  // Update it in place so the next hover uses the newly selected color.
  var secondaryImage = imageWrapper && imageWrapper.querySelector('.product-item__secondary-image');
  if (secondaryImage && imageWrapper.dataset.hoverImage) {
    setResponsiveProductCardImage(
      secondaryImage,
      imageWrapper.dataset.hoverImage,
      imageWrapper.dataset.hoverImageAlt || ''
    );
  } else if (imageWrapper && imageWrapper.matches(':hover') && cardLink) {
    createProductCardHoverImage(imageWrapper, cardLink);
  }

  if (variantId && options.updateNavigation !== false) {
    var productUrl = productItem.dataset.productUrl;
    productItem.querySelectorAll('a[href*="/products"]').forEach(function (link) {
      var destination = new URL(productUrl || link.href, window.location.origin);
      destination.searchParams.set('variant', variantId);
      link.href = destination.toString();
    });
    productItem.querySelectorAll('quick-buy-popover, quick-buy-drawer').forEach(function (quickBuy) {
      var href = new URL(productUrl || quickBuy.getAttribute('href') || '/', window.location.origin);
      href.searchParams.set('variant', variantId);
      quickBuy.setAttribute('href', href.toString());
    });
  }

  if (imageWrapper && imageWrapper.matches(':hover') && cardLink) {
    createProductCardHoverImage(imageWrapper, cardLink);
  }
}

function createProductCardHoverImage(imageWrapper, cardLink) {
  var source = imageWrapper.dataset.hoverImage;
  if (!source || cardLink.querySelector('.product-item__secondary-image')) return;

  var image = document.createElement('img');
  image.className = 'product-item__secondary-image';
  image.loading = 'lazy';
  image.decoding = 'async';
  image.fetchPriority = 'low';
  var primaryImage = cardLink.querySelector('.product-item__primary-image');
  image.sizes = primaryImage?.sizes || '';
  setResponsiveProductCardImage(image, source, imageWrapper.dataset.hoverImageAlt || primaryImage?.alt || '');
  cardLink.append(image);
  imageWrapper.classList.add('product-item__image-wrapper--multiple');
}

function prepareProductCardHoverImage(productItem) {
  var imageWrapper = productItem.querySelector('.product-item__image-wrapper');
  if (!imageWrapper) return;
  var swatches = Array.from(productItem.querySelectorAll('.product-item-meta__swatch-list .color-swatch'));
  if (!swatches.length) return;
  var currentColor = productItem.querySelector('.product-item__primary-image')?.dataset.currentColor?.toLowerCase();
  var currentSwatch = swatches.find(function (swatch) {
    return swatch.querySelector('.color-swatch__radio')?.value?.toLowerCase() === currentColor;
  }) || swatches.find(function (swatch) {
    return swatch.querySelector('.color-swatch__radio')?.checked;
  }) || swatches[0];
  if (currentSwatch) updateProductCardFromSwatch(currentSwatch, productItem, { updateNavigation: false });
}

function initializeProductCardInteractions() {
  if (document.documentElement.dataset.productCardInteractionsBound === 'true') return;
  document.documentElement.dataset.productCardInteractionsBound = 'true';
  var desktopHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('.product-item-meta__swatch-list .color-swatch__radio')) return;
    var colorSwatch = input.closest('.color-swatch');
    var productItem = input.closest('.product-item');
    if (colorSwatch && productItem) updateProductCardFromSwatch(colorSwatch, productItem);
  });

  document.addEventListener('pointerover', function (event) {
    if (!desktopHover.matches) return;
    var imageWrapper = event.target.closest('.product-item__image-wrapper');
    if (!imageWrapper || imageWrapper.contains(event.relatedTarget)) return;
    var productItem = imageWrapper.closest('.product-item');
    var cardLink = imageWrapper.querySelector('.product-item__aspect-ratio');
    if (!productItem || !cardLink) return;
    prepareProductCardHoverImage(productItem);
    createProductCardHoverImage(imageWrapper, cardLink);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeProductCardInteractions);
} else {
  initializeProductCardInteractions();
}
